export default "__VITE_ASSET__eefbf390__"